import { formatDate } from 'utilities/date';
import styles from './ArticleDate.module.scss';

export interface ArticleDateProps {
	date: string;
}

export const ArticleDate: React.FC<ArticleDateProps> = ({ date }) => <p className={styles.ArticleDate}>{formatDate(date, 'dd-mm-yyyy')}</p>;
